module.exports = __webpack_public_path__ + "img/pathology-version.1d0abeaa.png";